/**
 * Which chunks a camera view needs: `daedalus-core`'s `visibleChunks` (ADR-088 decision 1), re-exported so the
 * game's painter and the editor's density meter call the same function.
 */

export { visibleChunks, type ChunkRange, type ViewRect } from "daedalus-core";
